<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <router-link class="section" to="/saae-payments-imports">
                Importações SAAE
              </router-link>
              <i class="right chevron icon divider"></i>
              <div class="active section">Nova Importação</div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <form
        :class="['ui small', { error: anyError }, 'form']"
        v-autocomplete-off
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Importando...</div>
          </div>
          <div class="row">
            <div class="eight wide column">
              <div
                :class="['required', { error: errors.file }, 'field']"
                :data-content="errorsTo('file')"
              >
                <label for="saae-file">Arquivo de Retorno</label>
                <input
                  type="file"
                  id="saae-file"
                  @change="onFileChange"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="sixteen wide column">
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="submit"
                  type="button"
                  :class="['ui submit blue', { disabled: !file }, 'button']"
                >
                  <i class="upload icon"></i>Importar
                </button>
              </div>
            </div>
          </div>
          <div v-if="result" class="row">
            <div class="sixteen wide column">
              <div :class="['ui message', result.success ? 'success' : 'error']">
                <div class="header">{{ result.success ? 'Importação concluída' : 'Erro na importação' }}</div>
              </div>
              <table v-if="result.lines && result.lines.length" class="ui small celled table">
                <tbody>
                  <tr v-for="(line, index) in result.lines" :key="index" :class="lineClass(line)">
                    <td>{{ line }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';

export default {
  components: { Breadcrumb, PageLayout },

  data() {
    return {
      loading: false,
      errors: {},
      file: null,
      result: null
    };
  },

  computed: {
    anyError() {
      return !_.isEmpty(this.errors);
    }
  },

  methods: {
    onFileChange(event) {
      this.file = event.target.files[0] || null;
      this.result = null;
    },

    lineClass(line) {
      if (line.startsWith('[BAIXADO]')) return 'positive';
      if (line.startsWith('[JÁ PAGO]')) return 'warning';
      if (line.startsWith('[ERRO]')) return 'negative';
      if (line.startsWith('[NÃO ENCONTRADO]')) return 'negative';
      return '';
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    _setErrors(errors) {
      this.errors = _.clone(errors || {});
      setTimeout(() => {
        $('.error.field').popup();
      }, 100);
    },

    submit() {
      if (!this.file) return;

      this.loading = true;
      this.result = null;
      this._setErrors({});

      Api.saaePaymentsImports
        .create(this.file)
        .then(response => {
          this.result = {
            success: true,
            lines: (response.data.log || '').split('\n').filter(l => l.trim())
          };
          this.$toast.show('Importação realizada com sucesso', 'success');
        })
        .catch(error => {
          if (error.response) {
            const msg = error.response.data.error || 'Erro ao importar arquivo';
            this.result = { success: false, lines: [] };
            this.$toast.show(msg, 'error');
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    }
  }
};
</script>
